// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"a994656b","41":"3e1378ad","51":"52054cea","136":"2cd0c4cc","280":"7c5337e0","429":"653a735c","657":"5718a579","751":"044b94d7","754":"3e1378ad","861":"75e4617a","865":"031fc2f6","873":"6154a8ed","942":"c8820c57"}[chunkId] + ".chunk.css";
};